import { Route, Routes } from "react-router";
import Dashboard from "./Dashboard";
import { PermissionGuard } from "../newComponents/PermissionGuard";
import { AccessLevelEnum } from "@propertelligent/client-api";
import NoAccess from "../pages/NoAccess";
 const NewDashboard = () => {
  return (
    <Routes>
      <Route index element={
        <PermissionGuard permission="UserDashboard" level={AccessLevelEnum.ReadOnly} fallback={<NoAccess />}>
          <Dashboard />
        </PermissionGuard>
      } />
    </Routes>
  );
};

export default NewDashboard
